import type { DRFPaginationQueries } from '#/index'

export const getQueries = (queries: DRFPaginationQueries) => {
  let queriesString = '?'
  for (const [key, value] of Object.entries(queries)) {
    if (value) {
      queriesString += `${key}=${value}&`
    }
  }

  return queriesString === '?' ? '' : queriesString.slice(0, -1)
}
